// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { ArchiveResult_abstract } from './../abstract/SagaBase/ArchiveResult_abstract';
export class ArchiveResult extends ArchiveResult_abstract {}
